import { call, put } from 'redux-saga/effects'
import { push, go } from 'connected-react-router'
import { get, post, URL_VARIABLES } from 'services/api'
import { setToken } from 'redux/reducers/token'
import { getScreenByToken } from 'config/tokenRouter'

import { QUIZ_SUCCESS } from '../reducers/quiz'

export function* handleFetchQuestions(action) {
  const { token } = action.payload

  const { screen } = getScreenByToken(token)

  if (screen === 'process_finished') return

  const res = yield call(get, {
    url: `/onboarding/quiz`,
    token,
    source: URL_VARIABLES.ANTIFRAUDE,
  })

  if (!res || res.status === 200) {
    yield put({
      type: QUIZ_SUCCESS,
      payload: res?.data?.questions,
    })
  } else if (res.status === 403) {
    yield put(push(`/failed`))
    yield put(go(`/failed`))
  } else if (res.data.error === 'QUIZ_ALREADY_FINISHED') {
    yield put(push(`/result`))
    yield put(go(`/result`))
  } else {
    yield put(push(`/quiz-fail`))
    yield put(go(`/result`))
  }
}

export function* handleSubmitAnswers(action) {
  const { items, token } = action.payload

  const res = yield post({
    url: `/onboarding/quiz/validation`,
    token,
    data: { answers: items },
    source: URL_VARIABLES.ANTIFRAUDE,
  })

  if (res.status === 200) {
    if (res.data.questions) {
      yield put({
        type: QUIZ_SUCCESS,
        payload: res.data.questions,
      })
    } else if (res.data.approved && res.data.finished) {
      yield put(setToken(res.data.token))
      yield put(push(`/result`))
      yield put(go(`/result`))
    } else if (res.data.finished) {
      yield put(setToken(res.data.token))
      yield put(push(`/failed`))
      yield put(go(`/failed`))
    } else {
      yield put(setToken(res.data.token))
      yield put(push(`/quiz-fail`))
      yield put(go(`/quiz-fail`))
    }
  } else {
      yield put(push(`/quiz-fail`))
      yield put(push(`/quiz-fail`))
  }
}
